/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createCosh } from '../../factoriesAny.js';
export var coshDependencies = {
  typedDependencies: typedDependencies,
  createCosh: createCosh
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCosh.generated.js
// module id = 1512
// module chunks = 0